module.exports = __webpack_public_path__ + "static/media/mplayer_16.7e200ea0.ico";